import * as React from "react";
import { useTranslation } from "react-i18next";
import { StatusPage } from "./StatusPage";

type Props = {
  onRetry: () => void;
  variant?: "network" | "crash";
};

// Full-screen status fallback rendered via the shared StatusPage primitive.
// `network` (default) is the content-load/offline failure; `crash` is the
// render-error fallback used by ErrorBoundary. defaultValue everywhere:
// /api/translations/ may itself be unreachable in exactly these states.
export function ContentError({ onRetry, variant = "network" }: Props) {
  const { t } = useTranslation("errors");

  if (variant === "crash") {
    return (
      <StatusPage
        variant="error"
        eyebrow={t("crashEyebrow", "THE CONNECTION BROKE")}
        title={t("crashTitle", "Something disturbed the reading")}
        body={t("crashBody", "An unexpected error crossed the signal. A moment's pause usually restores it.")}
        cta={{ label: t("crashCta", "Reload the page"), onClick: onRetry }}
      />
    );
  }

  return (
    <StatusPage
      variant="offline"
      eyebrow={t("eyebrow", "THE SIGNAL DIMMED")}
      title={t("title", "We couldn't reach the page")}
      body={t("body", "The connection faded for a moment. Check your link and try once more.")}
      cta={{ label: t("tryAgain", "Try again"), onClick: onRetry }}
    />
  );
}
